import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectRank = (state : GlobalState) => state.food.rank;

export const foodRankSelector = createSelector(
    [selectRank],
    (data ) => data
)
